/*
 * @Descripttion:
 * @Date: 2022-03-21 11:38:35
 * @LastEditTime: 2022-12-15 11:20:46
 */
import axios from './axios-instance';


// 获取excel模板文件
export function getTemplateFile(params) {
  return axios({
    url: '/report/auth/all-template-config/get-template-info-by-key',
    method: 'get',
    params,
  });
}

// 数据导出
export function dataReport(data) {
  return axios({
    url: '/report/auth/center/order/report/export',
    method: 'post',
    data,
  });
}
// 文件导入api
export function uploadFile(url, data, process) {
  return axios({
    method: 'post',
    url,
    data,
    onUploadProgress: process,
  });
}

// 导出失败的数据
export function errorDataExport(url, data) {
  return axios({
    method: 'post',
    url,
    data,
    responseType: 'blob',
  });
}

export function apiDownloadFile(params, url) {
  url = url || '/coupon/marketing-file/manage/template/download';
  return axios({
    url,
    method: 'get',
    params,
    responseType: 'blob',
  });
}

export default {};
